import { NgModule } from '@angular/core';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    RouterModule,
    Routes,
} from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { MyProfileComponent } from './shared/layout/topbar/my-profile/my-profile.component';
import { HelpSectionComponent } from './main/common-ui-elements/help-section/help-section.component';
import { HelpSectionContentComponent } from './main/common-ui-elements/help-section-content/help-section-content.component';
import { buildLegacyRedirectRoutes } from './shared/routes/legacy-route-redirects';

const companyProfileRoute: Routes = [
    {
        path: 'company-profile',
        loadChildren: () =>
            import('@app/shared/layout/topbar/company-profile/company-profile.module').then(
                (m) => m.CompanyProfileModule
            ),
        data: { preload: true },
    },
];

const adminRoute: Routes = [
    {
        path: 'admin',
        loadChildren: () => import('@app/admin/admin.module').then((m) => m.AdminModule),
        data: { preload: true },
        canLoad: [AppRouteGuard],
    },
];

const mainFeatureRoutes: Routes = [
    { path: 'notifications', component: NotificationsComponent },
    ...companyProfileRoute,
    { path: 'tenant-settings', redirectTo: '/admin/tenant-settings', pathMatch: 'full' },
    // Admin, my-profile, and help-section must be registered before the empty-path main lazy route;
    // otherwise those URLs are absorbed by MainModule and never reach their components.
    ...adminRoute,
    { path: 'my-profile', component: MyProfileComponent },
    { path: 'myProfile', redirectTo: 'my-profile', pathMatch: 'full' },
    { path: 'help-section', component: HelpSectionComponent },
    { path: 'help-section/content', component: HelpSectionContentComponent },
    {
        path: '',
        loadChildren: () => import('@app/main/main.module').then((m) => m.MainModule),
        data: { preload: true },
    },
    { path: '**', redirectTo: 'dashboard' },
];

const appShellRoutes: Routes = [
    {
        path: '',
        component: AppComponent,
        canActivate: [AppRouteGuard],
        canActivateChild: [AppRouteGuard],
        children: mainFeatureRoutes,
    },
    ...buildLegacyRedirectRoutes(),
];

@NgModule({
    imports: [RouterModule.forChild(appShellRoutes)],
    exports: [RouterModule],
})
export class AppRoutingModule {
    constructor(private router: Router, private spinnerService: NgxSpinnerService) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (!event.url.startsWith('/account')) {
                    void this.spinnerService.show();
                }
                return;
            }

            if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                if (event instanceof NavigationEnd) {
                    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
                    ogUrlMeta?.setAttribute('content', window.location.href);
                }

                void this.spinnerService.hide();
            }
        });
    }
}
